<template>
  <div>
    <wallet-header :walletData="walletData" />
    <transactions-overview :stats="overviewStats" />
    <Transactions />
  </div>
</template>

<script>
import WalletHeader from "@/components/wallet/WalletHeader.vue";
import walletMixin from "@/mixins/wallet/walletMixin";
import TransactionsOverview from "@/components/wallet/TransactionsOverview.vue";
import Transactions from "@/components/wallet/Transactions.vue";

export default {
  name: "Summary",
  head: {
    link: [
      {
        rel: "stylesheet",
        href: "/assets/css/wallet.css",
      },
    ],
  },
  components: {
    WalletHeader,
    TransactionsOverview,
    Transactions,
  },
  mixins: [walletMixin],
  computed: {
    overviewStats() {
      if (!this.walletData) return [];

      const walletData = this.walletData.walletData || {};

      return [
        {
          label: "Total Withdrawals",
          value: walletData.totalWithdrawals || "0.00",
          unit: walletData.currency || "BTC",
          subtext: "",
          icon: "/assets/images/wallet/withdraws.png",
        },
        {
          label: "Pending Requests",
          value: walletData.pendingRequests || "0",
          unit: "",
          subtext: "",
          icon: "/assets/images/wallet/pending-request.png",
        },
        {
          label: "Completed Transactions",
          value: walletData.completedTransactions || "0",
          unit: "",
          subtext: "",
          icon: "/assets/images/wallet/right-check.png",
        },
      ];
    },
  },
};
</script>
